'use client';

import { c as _c } from "react/compiler-runtime";
import { Check } from 'lucide-react';
import { useRef, useState } from 'react';
import IconSort from '@/components/assets/icon_sort.svg';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ViverseButton from '@/components/ViverseButton';
import { cn } from '@/lib/utils';
import { SortValue } from '@/types/search';
type SortOption = {
  value: SortValue;
  label: string;
};
type SortByPopoverProps = {
  sortBy: string;
  onSortChange: (value: SortValue) => void;
  sortOptions: SortOption[];
  sortOption: SortOption | undefined;
};
export default function SortByPopover(t0) {
  const $ = _c(23);
  const {
    sortBy,
    onSortChange,
    sortOptions,
    sortOption
  } = t0;
  const [open, setOpen] = useState(false);
  const sortDropdownRef = useRef(null);
  let t1;
  if ($[0] !== open) {
    t1 = cn("flex min-w-fit items-center justify-between gap-2", {
      "bg-vive-primary-70 text-white": open
    });
    $[0] = open;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = open ? "fill-white" : "fill-vive-primary-20";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("size-4 shrink-0", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <IconSort className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = sortOption?.label;
  let t6;
  if ($[6] !== t1 || $[7] !== t4 || $[8] !== t5) {
    t6 = <PopoverTrigger asChild={true}><ViverseButton variant="icon3" size="silent2" className={t1}>{t4}{t5}</ViverseButton></PopoverTrigger>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onSortChange || $[11] !== sortBy || $[12] !== sortOptions) {
    let t8;
    if ($[14] !== onSortChange || $[15] !== sortBy) {
      t8 = option => <button key={option.value} onClick={() => {
        onSortChange(option.value);
        setOpen(false);
      }} className="group hover:bg-vive-primary-80/30 flex w-full items-center justify-between px-4 py-2 text-left text-sm text-white transition-colors first:rounded-t-[3px] last:rounded-b-[3px]"><span className={cn({
          "text-vive-brand-50": sortBy === option.value,
          "text-white": sortBy !== option.value
        })}>{option.label}</span>{sortBy === option.value && <Check className="stroke-vive-brand-50 size-4" />}</button>;
      $[14] = onSortChange;
      $[15] = sortBy;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = sortOptions.map(t8);
    $[10] = onSortChange;
    $[11] = sortBy;
    $[12] = sortOptions;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <PopoverContent ref={sortDropdownRef} className="w-48 rounded-[3px] border-none bg-[#212A3966] p-0 shadow-lg backdrop-blur-md" align="end" sideOffset={8}>{t7}</PopoverContent>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== open || $[20] !== t6 || $[21] !== t8) {
    t9 = <Popover open={open} onOpenChange={setOpen}>{t6}{t8}</Popover>;
    $[19] = open;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}